import React, {useEffect, useRef} from "react";

import L from 'leaflet';

const Map = () => {
  const mapRef = useRef(null)
  const osMapAttribution = 'OS OpenData maps. &copy; Crown copyright and database rights ' + new Date().getFullYear();

  useEffect(() => {
    const map = L.map(mapRef.current).setView([51.505, -0.9], 13);

    L.tileLayer('https://europe-west2-glasgowbeforethemotorway.cloudfunctions.net/glasgow-tile-layer/{z}/{x}/{y}.png', {
      attribution: osMapAttribution
    }).addTo(map);

    return () => map.remove();
  }, [])

  return (
    <div ref={mapRef} style={{height: (window.innerHeight - 75), marginTop: '5px'}} />
  )
}

export default Map;